import React, { FC, useCallback, useState } from 'react';
import { UitkButtonProps, UitkButtonSize, UitkOverlayButton, UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkText } from 'uitk-react-text';
interface CopyActionProps {
  copyValue: string;
}

const CopyButton = React.memo(function CopyButton(props: UitkButtonProps) {
  return (
    <UitkTertiaryButton className="copy-button" {...props}>
      <UitkIcon name="copy_content" size={UitkIconSize.SMALL} />
    </UitkTertiaryButton>
  );
});

const CopiedButton = React.memo(function CopiedButton(props: UitkButtonProps) {
  return (
    <UitkOverlayButton size={UitkButtonSize.SMALL} {...props}>
      <UitkText theme="inverse" size={200}>
        {'Copied'}
      </UitkText>
      <UitkIcon name="check" size={UitkIconSize.SMALL} />
    </UitkOverlayButton>
  );
});

export const CopyAction: FC<CopyActionProps> = ({ copyValue }) => {
  const [Button, setButton] = useState<React.NamedExoticComponent<UitkButtonProps>>(CopyButton);

  const copySnippetToClipboard = useCallback((e) => {
    navigator.clipboard.writeText(copyValue);
    toggleCopyButton(e);
  }, []);

  const toggleCopyButton = useCallback((e) => {
    e.stopPropagation();
    setButton(CopiedButton);
    setTimeout(() => {
      setButton(CopyButton);
    }, 3000);
  }, []);

  return <Button onClick={(e) => copySnippetToClipboard(e)} />;
};
